import AppleStatCard from "./UsageStatCard.jsx";
import HoverPopover from "./UsageHoverPopover.jsx";

import DollarIcon from '../icons/dollar.svg?react';
import CpuIcon from '../icons/cpu.svg?react';
import ChartIcon from '../icons/chartbarpeak.svg?react';


// Default values for all props to ensure no crash
function safeArray(val) {
  return Array.isArray(val) ? val : [];
}
function safeObj(val) {
  return val && typeof val === 'object' ? val : {};
}

export default function UsageStatsCards({
  spendByModelArr = [],
  spendTotal = 0,
  tokenTable = [],
  totalTokens = 0,
  top3 = [],
  topModel = "–",
  tokenByModel = {},
  spendByModel = {},
  modelColors = {},
  accentSpend = "#000",
  accentTokens = "#000",
  accentModel = "#000",
  selectedMonth = "",
  selectedYear = ""
}) {
  // Make sure we're working with arrays/objects, never null/undefined
  spendByModelArr = safeArray(spendByModelArr);
  tokenTable = safeArray(tokenTable);
  top3 = safeArray(top3);
  tokenByModel = safeObj(tokenByModel);
  spendByModel = safeObj(spendByModel);
  modelColors = safeObj(modelColors);

  const periodLabel = selectedMonth && selectedYear ? `${selectedMonth} ${selectedYear}` : "This month";

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-spacing-4 mb-spacing-3">
      {/* Spend Card */}
      <HoverPopover
        popover={
          <div>
            <div className="font-bold text-primary mb-spacing-2">Spend by Model</div>
            {!spendByModelArr.length ? (
              <div className="text-dls-small">No Data</div>
            ) : (
              <table className="text-dls-small w-full"><tbody>
                {spendByModelArr.map(([model, spend]) => (
                  <tr key={model}>
                    <td className="pr-spacing-2">
                      <span className="inline-block w-3 h-3 mr-spacing-1 rounded" style={{ background: modelColors[model] || 'var(--color-info)' }}/>
                      {model}
                    </td>
                    <td className="text-right pl-spacing-2">${spend?.toFixed?.(2) ?? "0.00"}</td>
                    <td className="pl-spacing-1 text-right text-secondary">
                      {spendTotal > 0 ? ((spend / spendTotal) * 100).toFixed(1) : "0"}%
                    </td>
                  </tr>
                ))}
              </tbody></table>
            )}
          </div>
        }
      >
        <AppleStatCard
          title="Total Spend"
          subtitle={periodLabel}
          value={`$${spendTotal?.toFixed?.(2) ?? "0.00"}`}
          valueColor={accentSpend}
          icon={<DollarIcon className="size-4 text-secondary"  />}
        />
      </HoverPopover>

      {/* Tokens Card */}
      <HoverPopover
        popover={
          <div>
            <div className="font-bold text-primary mb-spacing-2">Token Type Breakdown</div>
            {!tokenTable.length ? (
              <div className="text-dls-small">No Data</div>
            ) : (
              <table className="text-dls-small w-full"><tbody>
                {tokenTable.map(([type, count]) => (
                  <tr key={type}>
                    <td>{type}</td>
                    <td className="text-right pl-spacing-2">{count?.toLocaleString?.() ?? "0"}</td>
                    <td className="pl-spacing-1 text-right text-secondary">
                      {totalTokens > 0 ? ((count / totalTokens) * 100).toFixed(1) : "0"}%
                    </td>
                  </tr>
                ))}
                <tr className="border-t border-border-divider">
                  <td><b>Total</b></td>
                  <td className="text-right"><b>{totalTokens?.toLocaleString?.() ?? "0"}</b></td>
                  <td />
                </tr>
              </tbody></table>
            )}
          </div>
        }
      >
        <AppleStatCard
          title="Total Tokens"
          subtitle={periodLabel}
          value={totalTokens?.toLocaleString?.() ?? "0"}
          valueColor={accentTokens}
          icon={<CpuIcon className="size-4 text-secondary" />}
        />
      </HoverPopover>

      {/* Top Model Card */}
      <HoverPopover
        popover={
          <div>
            <div className="font-bold text-primary mb-spacing-2">Top 3 Models</div>
            {!top3.length ? (
              <div className="text-dls-small">No Data</div>
            ) : (
              <table className="text-dls-small w-full"><tbody>
                {top3.map(([model, tokens]) => (
                  <tr key={model}>
                    <td className="pr-spacing-2">
                      <span className="inline-block w-3 h-3 mr-spacing-1 rounded" style={{ background: modelColors[model] || 'var(--color-info)' }}/>
                      {model}
                    </td>
                    <td className="text-right pl-spacing-1">${spendByModel[model]?.toFixed?.(2) ?? "0.00"}</td>
                    <td className="text-right pl-spacing-3 text-secondary">
                      {tokens?.toLocaleString?.() ?? "0"} tokens
                    </td>
                  </tr>
                ))}
              </tbody></table>
            )}
          </div>
        }
      >
        <AppleStatCard
          title="Top Model"
          subtitle="Most used"
          value={topModel}
          valueColor={accentModel}
          icon={<ChartIcon className="size-4 text-secondary" />}
        />
      </HoverPopover>
    </div>
  );
}
